import type { GamingDisorderSymptomsProps } from '@/features/enrollment'
import { gamingDisorderSymptomsOptions } from '../validation/healthLegalValidation'

export default function GamingDisorderSymptoms({ enrollmentData, updateEnrollmentData, errors, handleCheckboxChange }: GamingDisorderSymptomsProps) {
  const selectedSymptoms = (enrollmentData.gamingDisorderSymptoms || []).filter((symptom: string) => symptom !== 'None of the above')
  const selectionCount = selectedSymptoms.length
  
  return (
    <div>
      <label className="block text-sm font-medium text-accent-900 mb-2">
        Select all internet gaming disorder symptoms that the individual has experienced or has been witnessed since playing video games <span className="text-red-500">*</span>
      </label>
      
      {/* Selection Counter */}
      <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-sm text-blue-800">
          <span className="font-medium">Selection Progress:</span>
          <span className={`ml-2 font-semibold ${selectionCount >= 5 && selectionCount <= 7 ? 'text-green-600' : 'text-orange-600'}`}>
            {selectionCount} of 5-7 required
          </span>
        </p>
        <p className="text-xs text-blue-600 mt-1">
          Please select between 5 and 7 symptoms (excluding "None of the above")
        </p>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {gamingDisorderSymptomsOptions.map((symptom) => (
          <label key={symptom} className={`flex items-center ${symptom === 'None of the above' ? 'bg-red-50 p-2 rounded border border-red-200' : ''}`}>
            <input 
              type="checkbox" 
              name="gamingDisorderSymptoms"
              value={symptom}
              checked={(enrollmentData.gamingDisorderSymptoms || []).includes(symptom)}
              onChange={(e) => handleCheckboxChange('gamingDisorderSymptoms', symptom, e.target.checked)}
              className="form-checkbox text-primary-600" 
            />
            <span className={`ml-2 ${symptom === 'None of the above' ? 'text-red-700 font-medium' : 'text-accent-700'}`}>
              {symptom}
              {symptom === 'None of the above' && (
                <span className="ml-2 text-xs text-red-600 font-bold">⚠️ WILL DISQUALIFY</span>
              )}
            </span>
          </label>
        ))}
      </div>
      {errors.gamingDisorderSymptoms && (
        <p className="mt-1 text-sm text-red-600">{errors.gamingDisorderSymptoms}</p>
      )}
    </div>
  )
}
